import { useQuery } from 'react-query'
import useLogout from './use-logout'
import ApiClient from '../lib/api-client'

function fetchNewToken () {
  return ApiClient.post('/auth/renew-token', {
    refreshToken: ApiClient.refreshToken
  }).then(data => data)
}

function useRefreshToken ({ enabled }) {
  const logout = useLogout()
  return useQuery(
    'refreshToken',
    async () => {
      if (!ApiClient.shouldRenewToken) {
        return null
      }
      const response = await fetchNewToken()
      return response
    },
    {
      enabled: Boolean(enabled),
      refetchInterval: 15 * 1000, // interval to check token expiry
      refetchIntervalInBackground: true,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      onError: (error) => {
        if (error?.code === 403) {
          logout()
        }
      },
      onSuccess: (response) => {
        if (response?.jwt) {
          ApiClient.setToken(response.jwt)
        }
      }
    }
  )
}

export default useRefreshToken
